import { render, staticRenderFns } from "./PRJ911M04.vue?vue&type=template&id=0367bace&scoped=true&"
import script from "./PRJ911M04.vue?vue&type=script&lang=js&"
export * from "./PRJ911M04.vue?vue&type=script&lang=js&"
import style0 from "./PRJ911M04.vue?vue&type=style&index=0&id=0367bace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0367bace",
  null
  
)

export default component.exports